import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

export default function CookieBanner({ onOpenPolicy }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("mobilhub_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => { localStorage.setItem("mobilhub_cookie_consent", "accepted"); setShow(false); };

  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[55] p-4" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl rounded-2xl border border-hairline bg-white p-4 sm:p-5 shadow-xl">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-warm/20 text-warm-dark"><Cookie className="h-5 w-5" /></span>
          <p className="flex-1 text-sm text-ink/75">
            Vi bruker kun nødvendige informasjonskapsler for at nettstedet skal fungere.{" "}
            <button onClick={() => onOpenPolicy("cookies")} className="font-medium text-electric underline" data-testid="cookie-policy-link">Les mer</button>.
          </p>
          <button onClick={accept} className="shrink-0 rounded-full bg-navy px-6 py-2.5 text-sm font-semibold text-white hover:bg-navy-800" data-testid="cookie-accept-button">
            Greit
          </button>
        </div>
      </div>
    </div>
  );
}
